import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";

import { CallState } from "redmond";
import { IStoreState } from "../../../../../reducers/types";
import {
  schedulePriceQuote,
  setContactInfo,
  scheduleBook,
  resetPaymentCardSelectedAccounts,
  setPriceQuote,
  listPaymentMethods,
} from "../../../actions/actions";
import { MobileHotelBookWorkflow } from "./component";
import {
  getIsBookingValid,
  getPollPriceQuoteCallState,
  getPriceQuote,
  getSelectedPaymentMethodId,
  getSession,
  getUserSelectedTravelerId,
  hasNoUserPassengersSelector,
  getConfirmationDetails,
  getConfirmationPhoneNumber,
  getConfirmationEmail,
  getPriceDifferenceAcknowledged,
  getSchedulePriceQuoteCallState,
  getPriceQuoteErrors,
  getConfirmationDetailsError,
  getOffers,
  getRewardsPaymentAccountReferenceId,
  getIsTravelWalletPaymentOnly,
  getCreditToApply,
  getRoomsCountInBook,
  getHotelBookChosenProduct,
  getHotelBookChosenProductIndex,
  getHotelBookChosenRoomInfo,
  getHotelBookSelectedAvailability,
  hotelBookTypeSelector,
  getFromDateInBook,
  getUntilDateInBook,
  getApplicableCredit,
  getOfferToApply,
  getShowRequoteSuccessBanner,
} from "../../../reducer";
import {
  getHotelShopCancellationSummary,
  hotelCfarQuoteFromChosenRoomProductSelector,
  isAddOnOptionAvailableSelector,
} from "../../../../shop/reducer/selectors";
import { fetchRewardsAccounts } from "../../../../rewards/actions/actions";
import {
  getAllAncillaries,
  hasCfarAttached,
  isHotelCfarRefundDisplayShowAmountAdditionalPlacesEnabledSelector,
} from "../../../../ancillary/reducer";
import { getIsTravelApp } from "../../../../availability/reducer";

export const mapStateToProps = (state: IStoreState) => ({
  priceQuote: getPriceQuote(state),
  priceQuoteInProgress:
    getSchedulePriceQuoteCallState(state) === CallState.InProcess ||
    getPollPriceQuoteCallState(state) === CallState.InProcess,
  priceQuoteErrors: getPriceQuoteErrors(state),
  currentSession: getSession(state),
  paymentMethodId: getSelectedPaymentMethodId(state),
  selectedTravelerId: getUserSelectedTravelerId(state),
  chosenProduct: getHotelBookChosenProduct(state),
  selectedLodging: getHotelBookSelectedAvailability(state),
  roomInfoProduct: getHotelBookChosenRoomInfo(state),
  chosenProductIndex: getHotelBookChosenProductIndex(state),
  isBookingValid: getIsBookingValid(state),
  hasNoUserPassengers: hasNoUserPassengersSelector(state),
  reservation: getConfirmationDetails(state),
  confirmationEmail: getConfirmationEmail(state),
  confirmationPhoneNumber: getConfirmationPhoneNumber(state),
  priceDifferenceAcknowledged: getPriceDifferenceAcknowledged(state),
  confirmationDetailsErrors: getConfirmationDetailsError(state),
  offers: getOffers(state),
  rewardsPaymentAccountReferenceId: getRewardsPaymentAccountReferenceId(state),
  roomsCount: getRoomsCountInBook(state),
  credit: getApplicableCredit(state),
  isTravelWalletPaymentOnly: getIsTravelWalletPaymentOnly(state),
  creditToApply: getCreditToApply(state),
  isAddOnOptionAvailable: isAddOnOptionAvailableSelector(state),
  ancillaries: getAllAncillaries(state),
  hasCfarAttached: hasCfarAttached(state),
  hotelCfarQuote: hotelCfarQuoteFromChosenRoomProductSelector(state),
  hotelBookType: hotelBookTypeSelector(state),
  isHotelCfarRefundDisplayShowAmountAdditionalPlaces:
    isHotelCfarRefundDisplayShowAmountAdditionalPlacesEnabledSelector(state),
  checkIn: getFromDateInBook(state),
  checkOut: getUntilDateInBook(state),
  cancellationSummary: getHotelShopCancellationSummary(state),
  isTravelApp: getIsTravelApp(state),
  offerToApply: getOfferToApply(state),
  showRequoteSuccessBanner: getShowRequoteSuccessBanner(state),
});

export const mapDispatchToProps = {
  schedulePriceQuote,
  setContactInfo,
  scheduleBook,
  resetPaymentCardSelectedAccounts,
  setPriceQuote,
  listPaymentMethods,
  fetchRewardsAccounts,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type MobileHotelBookWorkflowConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedMobileHotelBookWorkflow = withRouter(
  connector(MobileHotelBookWorkflow)
);
